import { createSlice, getDefaultMiddleware } from "@reduxjs/toolkit";
let id = 1;
const modalsSlice = createSlice({
  name: "ui",
  initialState: [],
  reducers: {
    addModal(state: any[], action) {
      let tmp = Object.assign({}, { ...action.payload, id: id++ });
      state.push(tmp);
    },
    removeModal(state: any[], action): any[] {
      return state.filter((i: any) => i.id !== action.payload);
    },
    removeAll(): any[] {
      return [];
    },
  },
});

export const { addModal, removeModal, removeAll } = modalsSlice.actions;
export enum ModalType {
  Alert,
  Confirm,
  ActionConfirm,
  FormTextInput,
  FormAmountInput,
  EmailForm,
  Success,
  Failed,
  Closable,
  Popup,
  FormCreateAuction,
  Reward,
  ActionConfirmBirthday,
  TelegramBot
}
export default modalsSlice.reducer;
